import { getChildDetailsQueryParams } from "Components/Features/CheckPrice/checkPriceQueryParamUtils";
import { getChildAgeDatesOfBirth } from "Components/InsuranceAdvice/insuranceAdviceUtils";
import { Cart } from "Store/cart/cartInterfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { ChildProduct } from "Store/interfaces/products/checkout/lifeProducts/ChildProduct";
import { removeItems } from "Utils/arrayUtils";
import { mapToDateString } from "Utils/dateUtils";
import { isDefined } from "Utils/functions";
import { format } from "date-fns";
import { ChildProductDetailsFormValues } from "./childProductDetailsInterfaces";

export const getChildProductDetailsInitialFormValues = (
  cart: Cart | null,
): Partial<ChildProductDetailsFormValues> => {
  const childIndex = getChildDetailsQueryParams().childIndex;
  const childDatesOfBirth = (
    cart?.advice?.adviceProductValues?.childDatesOfBirth ?? []
  ).map(mapToDateString);

  if (!isDefined(childIndex) || childDatesOfBirth.length === 0) {
    return {
      childFirstName: undefined,
      childBirthDate: undefined,
      parentGuardian: undefined,
    };
  }

  const childBirthDatesNotInCart = getChildBirthDatesNotInCart(
    childDatesOfBirth,
    cart,
  );

  return {
    childFirstName: undefined,
    childBirthDate: format(childBirthDatesNotInCart[childIndex], "dd.MM.yyyy"),
    parentGuardian: undefined,
  };
};

export const getChildBirthDatesNotInCart = (
  childDatesOfBirth: string[],
  cart: Cart | null,
): Date[] => {
  if (!isDefined(cart)) {
    return [];
  }

  const childDatesOfBirthInCart = cart.products
    .filter(
      (product): product is ChildProduct =>
        product.name === INSURANCE_NAME_VALUE.NEW_CHILD ||
        product.name === INSURANCE_NAME_VALUE.CHILD,
    )
    .map((product) => product.childDateOfBirth);

  const datesNotInCart = removeItems(
    childDatesOfBirth,
    childDatesOfBirthInCart,
  );

  return getChildAgeDatesOfBirth(datesNotInCart);
};
